@if (!isEnfermedadesGraves) {
<div [formGroup]="form" class="form-item-card card border form-modal rounded-3">
  <div class="card-header bg-white">
    <div class="fs-6 fw-bold m-0 d-flex gap-2 align-items-center">
      <app-icon [size]="26" [strokeWidth]="2" color="#ce343c" name="circle-fading-plus"></app-icon>
      Coberturas para {{ insuredCount > 1 ? 'tus asegurados' : 'tu asegurado' }}
    </div>
  </div>
  <div class="card-body pt-2 p-3 pb-0">
    @if (!hasNoPrimaryCoverage) {
    <div class="row border-bottom border-3 pb-2">
      <div class="col col-12 col-md-8">
        <label class="form-label small fw-semibold text-muted text-uppercase uppercase d-block mb-2">Cobertura
          Principal</label>
        <div class="form-check-inline py-1">
          <label class="form-check-label fw-bold d-flex gap-2 align-items-center">
            {{ primaryCoverage?.name || 'Cobertura principal' }}
            <button #infoButton (click)="onInfoClick($event)"
              [attr.aria-label]="'Ver ' + (primaryCoverage?.name || 'Cobertura')"
              [attr.data-info-content]="primaryCoverage?.description || ''"
              [attr.data-info-title]="primaryCoverage?.name || ''"
              class=" btn btn-sm p-1 btn-outline-light text-muted border-0 rounded-circle"
              data-bs-custom-class="custom-popover" data-bs-placement="top" data-bs-toggle="popover" type="button">
              <app-icon [size]="24" [strokeWidth]="2" color="#9e9e9e" name="info"></app-icon>
            </button>
          </label>
        </div>
      </div>
      <div class="col" style="padding-left: 0px;">
        <label style="padding-left: 12px;" class="form-label small fw-semibold text-muted text-uppercase uppercase"
          for="insuranceItemMainCoverage">Monto a asegurar</label>
        <app-coverage-amount-input formControlName="mainCoverage" [currency]="form.get('currency')?.value ?? 'RD$'"
          [min]="getCoverageRange(primaryCoverage)?.minAmount" [max]="getCoverageRange(primaryCoverage)?.maxAmount"
          [placeholder]="'0.00'" [readonly]="isFixedLimit(primaryCoverage)">
        </app-coverage-amount-input>
        @if (form.get('mainCoverage')?.touched && form.get('mainCoverage')?.hasError('required')) {
        <div class="text-danger small mt-1">Monto requerido</div>
        }
        @if (ageAmountCap != null) {
        <div class="small mt-1" [class.text-danger]="form.get('mainCoverage')?.hasError('max')"
          [class.text-muted]="!form.get('mainCoverage')?.hasError('max')">
          Para la edad del asegurado el monto máximo es {{ form.get('currency')?.value === 'USD' ? 'US$' : 'RD$' }}
          {{ ageAmountCap | number: '1.0-2' }}.
        </div>
        }
      </div>
    </div>
    }
    @for (cov of calculatedCoverages; track cov.id) {
    <div class="row pt-2 pb-1 border-bottom border-3">
      <div class="col-12 col-md-8">
        <label class="form-label mb-0 small fw-semibold text-muted text-uppercase uppercase d-block mb-2">
          {{ cov.name }}
        </label>
        <div class="form-check-inline py-1">
          <label class="form-check-label fw-bold d-flex gap-2 align-items-center">
            {{ cov.description || cov.name }}
            <button #infoButton (click)="onInfoClick($event)" [attr.aria-label]="'Ver ' + (cov.name || 'Cobertura')"
              [attr.data-info-content]="cov.description || ''" [attr.data-info-title]="cov.name || ''"
              class=" btn btn-sm p-1 btn-outline-light text-muted border-0 rounded-circle"
              data-bs-custom-class="custom-popover" data-bs-placement="top" data-bs-toggle="popover" type="button">
              <app-icon [size]="24" [strokeWidth]="2" color="#9e9e9e" name="info"></app-icon>
            </button>
          </label>
        </div>
      </div>
      <div class="col">
        <label class="form-label small fw-semibold text-muted text-uppercase uppercase">Monto Calculado</label>
        <div class="input-group">
          <span class="input-group-text ps-2 pe-1 bg-transparent border-end-0 border-success"><span
              class="badge fw-semibold text-secondary bg-secondary-subtle text-uppercase">{{ form.get('currency')?.value
              ===
              'USD' ? 'US$' : 'RD$' }}</span></span>
          <input class="form-control py-2 focus-ring border-success fw-bold focus-ring-success border-start-0" disabled
            type="text" value="Calculado">
        </div>
      </div>
    </div>
    }
    @if(additionalCoverages.length){
    <div class="row pt-2 pb-1">
      <div class="col-12 col-md-8">
        <label class="form-label mb-0 small fw-semibold text-muted text-uppercase uppercase d-block mb-2">Agrega
          Coberturas Adicionales</label>
      </div>
      <div class="col d-none d-md-block">
        <label class="form-label mb-0 small fw-semibold text-muted text-uppercase uppercase"
          for="insuranceItemMainCoverage">Monto a asegurar</label>
      </div>
    </div>
    @for (cov of additionalCoverages; let last = $last; track cov) {
    <div [ngClass]="{ 'border-bottom': !last }" class="row g-2 row-item-form align-items-center order-1 py-2">
      <div class="col-12 col-md-8">
        <div class="form-check form-check-inline align-items-center d-flex gap-2 d-flex align-items-top gap-2">
          <input [formControlName]="selectedKey(cov)" [id]="'covSel_' + uniqueId + '_' + (cov.id || cov.name)"
            class="form-check-input focus-ring focus-ring-success" sharedFormInput type="checkbox">
          <label [for]="'covSel_' + uniqueId + '_' + (cov.id || cov.name)"
            class="form-check-label lh-sm fw-bold d-flex gap-2 align-items-center">
            {{ cov.name }}
            <button #infoButton (click)="onInfoClick($event)"
              [attr.aria-label]="'Más información sobre ' + (cov.name || 'cobertura')"
              [attr.data-info-content]="cov.description || ''" [attr.data-info-title]="cov.name || ''"
              class=" btn btn-sm p-0 btn-outline-light text-muted border-0 rounded-circle"
              data-bs-custom-class="custom-popover" data-bs-placement="top" data-bs-toggle="popover" type="button">
              <app-icon [size]="18" [strokeWidth]="2" color="#9e9e9e" name="info"></app-icon>
            </button>
          </label>
          @if (form.get(selectedKey(cov))?.disabled) {
          <small class="text-muted fst-italic d-block mt-1">No disponible para la edad del asegurado</small>
          }
        </div>
      </div>
      <div class="col">
        <div class="d-block d-md-none mb-1 text-muted small text-uppercase">Monto a asegurar</div>
        <app-coverage-amount-input [formControlName]="amountKey(cov)" [currency]="form.get('currency')?.value ?? 'RD$'"
          [min]="getCoverageRange(cov)?.minAmount" [max]="getEffectiveMax(cov)"
          [readonly]="isFixedLimit(cov) || hasFraction(cov)">
        </app-coverage-amount-input>
        @if (form.get(amountKey(cov))?.touched && form.get(amountKey(cov))?.hasError('max')) {
        <div class="text-danger small mt-1">
          El valor asegurado no puede superar el monto de la cobertura principal.
        </div>
        }
        @if (form.get(amountKey(cov))?.touched && form.get(amountKey(cov))?.hasError('required')) {
        <div class="text-danger small mt-1">
          Debe ingresar un monto para la cobertura seleccionada.
        </div>
        }
      </div>
    </div>
    }
    }
    @if (coverageError) {
    <div class="alert alert-danger d-flex align-items-center gap-2 mt-2 py-2 small fw-semibold" role="alert">
      <app-icon [size]="18" [strokeWidth]="2" name="alert-circle"></app-icon>
      {{ coverageError }}
    </div>
    }
  </div>
</div>
}